import { render, staticRenderFns } from "./message-timestamp.vue?vue&type=template&id=313cffa7&scoped=true"
import script from "./message-timestamp.vue?vue&type=script&lang=ts"
export * from "./message-timestamp.vue?vue&type=script&lang=ts"
import style0 from "./message-timestamp.vue?vue&type=style&index=0&id=313cffa7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313cffa7",
  null
  
)

export default component.exports